import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "terms-page-wr" }
const _hoisted_2 = { class: "terms-wr" }
const _hoisted_3 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "info-wr" }, [
        _createElementVNode("h1", null, "Your Account Is Connected!"),
        _createElementVNode("p", null, "You can now create contracts using your REI/Realworks account."),
        _createElementVNode("p", null, "You can close this window and go back to the app.")
      ], -1)),
      ($setup.isTokenReady)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button button primary",
            type: "button",
            onClick: $setup.onBack
          }, "Go Back"))
        : _createCommentVNode("", true),
      (!$setup.isTokenReady)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ])
  ]))
}